export const getCotesProvenceData = () => ({
  name: "Côtes de Provence",
  region: "Provence",
  country: "France",
  description: "Côtes de Provence est la plus grande appellation de Provence, célèbre pour ses rosés frais et fruités, ainsi que ses rouges et blancs de qualité.",
  type: "subregion",
  area: "20,000 ha",
  production: "1,200,000 hectolitres",
  mapAreas: [
    { region: "Côtes de Provence", x: 6.2, y: 43.4, color: "#4B164C", size: 6 }
  ],
  characteristics: {
    climate: "Climat méditerranéen, ensoleillement exceptionnel",
    soil: "Sols variés : schistes, calcaires, grès, argiles",
    viticulture: "Viticulture moderne et traditionnelle"
  },
  wineStyles: {
    red: "Vins rouges fruités et souples",
    white: "Vins blancs frais et aromatiques",
    rose: "Rosés frais, fruités et élégants"
  },
  history: "La viticulture dans les Côtes de Provence remonte à l'Antiquité. L'appellation est aujourd'hui reconnue mondialement pour ses rosés.",
  foodPairing: "Cuisine méditerranéenne, poissons grillés, salades, fromages frais",
  grapeVarieties: {
    red: ["Grenache", "Syrah", "Mourvèdre", "Cinsault"],
    white: ["Rolle", "Clairette", "Ugni Blanc", "Sémillon"],
    rose: ["Grenache", "Cinsault", "Syrah", "Mourvèdre"]
  },
  subregions: {}
}); 